export default __webpack_public_path__ + "static/media/ic_warning_login.fe5fc380.svg";